export default [
  {
    path: "/wt-k1-promotion-list",
    name: "K1PromotionList",
    meta: {
      title: "K1促销专区",
      showHeader: true,
      showCart: true
    },
    component: () =>
      import(
        /* webpackChunkName: "k1-promotion" */ "@/views/k1-promotion/K1PromotionList.vue"
      )
  },
  {
    path: "/wt-k1-promotion-detail/:code",
    name: "K1PromotionDetail",
    meta: { title: "详情", showHeader: true, showCart: true },
    component: () =>
      import(
        /* webpackChunkName: "k1-promotion" */ "@/views/k1-promotion/K1PromotionDetail.vue"
      )
  }
];
